// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileIsBlocked":"jb_a bhm_ea bhm_ti"};